import space from './space'

const COLMUNS = 12
const GUTTER = space.xs
const GUTTER_DESKTOP = space.xl

export {COLMUNS, GUTTER, GUTTER_DESKTOP}
